import { useQuery } from '@tanstack/react-query'
import { fetchDocumentLink, fetchSignedDownloadURL } from '../api'
import { YesObject } from '@yes.technology/react-toolkit'

type UseDocumentLinkArgs = {
  uuid?: string
  url?: YesObject
  type?: 'document' | 'interaction-document'
}

export default function useDocumentLink({
  uuid,
  url,
  type = 'document'
}: UseDocumentLinkArgs) {
  const { data, error, isLoading } = useQuery<string, Error>({
    queryKey: ['DocumentLink', uuid],
    queryFn: async () => {
      if (type === 'interaction-document' && url) {
        const fileKey = new URL(url.des).pathname.replace(/^\//, '')

        const response = await fetchSignedDownloadURL(fileKey)
        return response.signed_url
      }

      return fetchDocumentLink(uuid as string)
    },
    enabled: !!uuid || !!url
  })

  return {
    data,
    error,
    isLoading
  }
}
